const CONFIG = {
  // API位置
  // API_SERVER: 'https://localhost:5001',
  API_SERVER: 'https://odm.hsinchu.gov.tw/api',
  // 圖床/檔案位置
  FILE_URL: 'https://odm.hsinchu.gov.tw/',
}

export { CONFIG }
